/* eslint-disable ember/no-computed-properties-in-native-classes, ember/require-computed-property-dependencies */
import { tracked } from '@glimmer/tracking';
import { service } from '@ember/service';
import SchoolOptionsController from '../school-options';
import { action, computed } from '@ember/object';
import { isEmpty } from '@ember/utils';
import config from 'linced-app/config/environment';

export default class BasicDetailsController extends SchoolOptionsController {
  @action
  setEmailAddress(value) {
    this.emailAddress = value;
  }

  @action
  setPhone(value) {
    this.phone = value;
  }

  // Services
  @service
  store;

  @tracked emailAddress = '';
  @tracked phone = '';
  @tracked physicalAddress = null;
  @tracked postalAddress = null;

  @computed(
    'emailAddress',
    'phone',
    'physicalAddress.{number,street,locality,district,region,postcode}',
    'postalAddress.{number,street,locality,district,region,postcode}',
    'school',
  )
  get isDirty() {
    return (
      this.emailAddress !== this.school.emailAddress ||
      this.phone !== this.school.phone ||
      !this.addressEq(this.physicalAddress, this.school.physicalAddress) ||
      !this.addressEq(this.postalAddress, this.school.postalAddress)
    );
  }

  addressEq(a, b) {
    return (
      a.number === b.number &&
      a.street === b.street &&
      a.locality === b.locality &&
      a.district === b.district &&
      a.region === b.region &&
      a.postcode === b.postcode
    );
  }

  resetDetails() {
    this.emailAddress = this.school.emailAddress;
    this.phone = this.school.phone;
    this.physicalAddress = this.school.physicalAddress.copy();
    this.postalAddress = this.school.postalAddress.copy();
  }

  @action
  save() {
    let schoolId = this.school.id;
    let url = `${config.APP.apiHost}/schools/v4/schools/${schoolId}/:setDetails`;
    let data = {
      school: {
        emailAddress: this.emailAddress,
        phone: this.phone,
        physicalAddress: this.physicalAddress,
        postalAddress: this.postalAddress,
      },
    };
    let chain = this.fetch
      .post(url, { data })
      .then((resp) => {
        // Roll back to clear dirty flags.
        this.school.rollbackAttributes();
        // Push the updated school record into the store.
        this.store.pushPayload('school', resp);
        // Reset the local properties.
        this.resetDetails();
        // Notify about success.
        this.toaster.success('School details saved.');
      })
      .catch(() => {
        this.toaster.error(`Error saving school details.`);
      });

    // Trigger any requested additional action
    let onSave = this.onSave;
    if (!isEmpty(onSave)) {
      chain.then(() => {
        onSave(this.school);
      });
    }
  }
}
